import { Component, inject } from '@angular/core';
import { LocalRoadService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocalRoadCreateDto,
  LocalRoadDto,
  LocalRoadExcelDownloadDto,
  LocalRoadUpdateDto,
} from '../proxy/planning/dtos/local-road';
import { LOCALROAD_CONFIG, LOCALROAD_FIELDS } from './local-road.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-local-road',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocalRoadService, ConfirmationService],
  templateUrl: './local-road.html',
  styleUrl: './local-road.scss',
})
export class LocalRoad extends BaseHierarchicalCrudComponent<
  LocalRoadDto,
  LocalRoadCreateDto,
  LocalRoadUpdateDto,
  LocalRoadExcelDownloadDto
> {
  service = inject(LocalRoadService);
  config = LOCALROAD_CONFIG;
  fields = LOCALROAD_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocalRoadDto): LocalRoadUpdateDto {
    return {
      name: data.name,
      locationId: data.locationId,
      localCorridorId: data.localCorridorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LocalRoad';
  }
}
